import dialCodes from "../../utility/areaDialCodes.json";
import type { IPhoneInputProps } from "../../types";
import { Radio, TextField, FormLabel, RadioGroup, FormControl, Autocomplete, FormControlLabel } from "@mui/material";

export default function PhoneInput(props: IPhoneInputProps) {
  const {
    text,
    isSMS,
    phoneNumber,
    dialCode,
    error,
    styles,
    handleAreaCodeChange,
    handlePhoneChange,
    handleIsSMSChange,
  } = props;

  return (
    <>
      <FormControl fullWidth sx={{ alignItems: "center", my: 2 }}>
        <FormLabel>{text.isSMS}</FormLabel>
        <RadioGroup sx={{ flexDirection: "row" }} value={isSMS} onChange={handleIsSMSChange}>
          <FormControlLabel value={true} control={<Radio />} label={text.yes} />

          <FormControlLabel value={false} control={<Radio />} label={text.no} />
        </RadioGroup>
      </FormControl>

      <Autocomplete
        fullWidth
        options={dialCodes}
        getOptionLabel={(dialCode) => dialCode.name}
        onChange={handleAreaCodeChange}
        renderInput={(params) => <TextField {...params} label={text.country} />}
        sx={styles.space}
      />

      <TextField
        fullWidth
        required
        label={text.phone}
        name="email"
        size="medium"
        value={phoneNumber ? phoneNumber : ""}
        onChange={handlePhoneChange}
        error={error && phoneNumber !== dialCode}
        disabled={!dialCode}
        sx={styles.space}
      />
    </>
  );
}
